import { useEffect, useState } from "react";
import { Auth } from '@supabase/auth-ui-react';
import { ThemeSupa } from '@supabase/auth-ui-shared';
import { supabase } from '../lib/supabaseClient';
import './LoginPage.css';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function LoginPage() {
  
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const viewParam = searchParams.get("view");
  const [authView, setAuthView] = useState(viewParam === "sign_up" ? "sign_up" : "sign_in");

  const [email, setEmail] = useState("");
  const [forgotMessage, setForgotMessage] = useState("");

  useEffect(() => {
    setAuthView(viewParam === "sign_up" ? "sign_up" : "sign_in");
  }, [viewParam]);

  const rawRedirect = searchParams.get("redirect");
  const redirectParam = rawRedirect === "/" ? "/browse" : (rawRedirect ?? "/browse");

  useEffect(() => {
    const { data: authListener } = supabase.auth.onAuthStateChange(async (event, session) => {
      if (event === "SIGNED_IN") {
        const intendedSignup = localStorage.getItem("signupIntent") === "true";
        const pendingRecId = localStorage.getItem("pendingSave");

        if (intendedSignup) {
          localStorage.setItem("isNewUser", "true");
          localStorage.removeItem("signupIntent");
        }
      
        localStorage.setItem("redirectReason", intendedSignup ? "signup" : "login");
        console.log(localStorage.getItem("redirectReason"));
  
        if (pendingRecId) {
          const { error } = await supabase
            .from("user_recommendations")
            .upsert(
              {
                user_id: session.user.id,
                recommendation_id: pendingRecId,
              },
              { onConflict: ["user_id", "recommendation_id"] }
            );
  
          if (error) {
            console.error("❌ Error saving after login:", error);
          } else {
            console.log("✅ Rec saved after login:", pendingRecId);
          }
          localStorage.removeItem("pendingSave");
        }
  
        navigate(redirectParam, { replace: true });
      }
    });
  
    return () => authListener?.subscription?.unsubscribe();
  }, [navigate, redirectParam]);

  async function handleForgotPassword(e) {
    e.preventDefault();
    setForgotMessage("");

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: "http://pod-recs.com/browse",
    });

    if (error) {
      setForgotMessage(error.message);
    } else {
      setForgotMessage("Login link sent! Check your inbox.");
    }
  }

  return (
    <div className="login-page-bg">
      <div className="login-card">
        <h1 className="login-title">
          {authView === "sign_in" ? "Welcome back" : authView === "sign_up" ? "Welcome" : "Login With Link"}
        </h1>

        <p className="login-subtitle">
          {authView === "sign_in"
            ? "Log in to access your saved recs!"
            : authView === "sign_up"
            ? "Sign up to start saving your fave recs 💛"
            : "We'll send you a link to log in with ✨"}
        </p>

        {authView === "forgotten_password" ? (
          <>
        <form onSubmit={handleForgotPassword}>
        <div className="auth-input-container">
          <input
            type="email"
            className="auth-input"
            placeholder="Your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="auth-input-container" style={{ marginTop: "24px" }}>
          <button
            type="submit"
            className="auth-button"
            style={{
              width: "100%",
              maxWidth: "280px",
              padding: "16px 24px",
              fontSize: "18px",
              fontWeight: "700",
              borderRadius: "60px",
              fontFamily: "'Lovelo', sans-serif",
              backgroundColor: "#def339",
              textTransform: "uppercase",
              letterSpacing: "1px",
              color: "#000",
              cursor: "pointer",
              border: "none",
              transition: "transform 0.2s ease, box-shadow 0.2s ease",
              boxShadow: "0 3px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            Send Login Link
          </button>
        </div>
        </form>


            {forgotMessage && (
              <p style={{ marginTop: "16px", fontSize: "14px", color: forgotMessage.includes("sent") ? "green" : "red" }}>
                {forgotMessage}
              </p>
            )}
          </>
        ) : (
          <Auth
            supabaseClient={supabase}
            view={authView}
            showLinks={false}
            magicLink={false}
            providers={[]}
            appearance={{
              theme: ThemeSupa,
              variables: {
                default: {
                  colors: {
                    brand: '#def339',
                    brandAccent: '#c9dd29',
                    messageText: '#444',
                    messageTextDanger: '#e53935',
                    textButton: '#000',
                  },
                  radii: {
                    borderRadiusButton: '10px',
                    inputBorderRadius: '10px',
                  },
                  fonts: {
                    bodyFontFamily: 'Helvetica Neue, sans-serif',
                    buttonFontWeight: '600',
                  },
                },
              },
            }}
            localization={{
              variables: {
                sign_in: {
                  email_label: '',
                  password_label: '',
                  button_label: 'Log in',
                  error_email_or_password: 'Incorrect email or password',
                },
                sign_up: {
                  email_label: '',
                  password_label: '',
                  button_label: 'Create account',
                },
              },
            }}
          />
        )}

        {authView === "sign_in" ? (
          <button onClick={() => {
            localStorage.setItem("signupIntent", "true");
            setAuthView("sign_up");
          }} className="login-switch-button">
            Create an account
          </button>
        ) : (
          <button onClick={() => setAuthView("sign_in")} className="login-switch-button">
            Back to login
          </button>
        )}

        {/* {authView === "sign_in" && (
          <button
            onClick={() => setAuthView("forgotten_password")}
            className="login-switch-button"
            style={{ marginTop: "8px" }}
          >
            Log in with a link     
          </button>
        )} */}
      </div>
    </div>
  );
}
